import { Component, OnInit } from '@angular/core';
import { BaseTableComponent } from '../../../shared/tables/base-table/base-table';
import { BehaviorCodeReactionsTableColumnsEnum } from '../behavior-code-reactions-models/behavior-code-reactions-table-columns.enum';
import {
  BehaviorCodeReactionUpdateDto,
  PrivilegeEnum,
  ReactionTypeEnum
} from '@whetstoneeducation/hero-common';
import { DEFAULT_DIALOG_RESULT } from '../../../shared/confirmation-dialog/confirmation-dialog-options.interface';
import { AppConfirmationDialogService } from '../../../shared/confirmation-dialog/confirmation-dialog.service';
import { AppToastManagerService } from '../../../shared/services/toast-manager.service';
import { AppBehaviorCodeReactionsService } from '../behavior-code-reactions.service';
import { AppPrivilegesService } from '../../auth/privileges.service';

@Component({
  selector: 'app-behavior-codes-reactions-table',
  templateUrl: './behavior-codes-reactions-table.template.html',
  styleUrls: ['./behavior-codes-reactions-table.scss']
})
export class AppBehaviorCodesReactionsTableComponent
  extends BaseTableComponent<any>
  implements OnInit
{
  public get displayedColumns() {
    return Object.values(BehaviorCodeReactionsTableColumnsEnum);
  }

  public columnValues = {
    [BehaviorCodeReactionsTableColumnsEnum.NAME]: ['reaction', 'name'],
    [BehaviorCodeReactionsTableColumnsEnum.POINTS]: ['points'],
    [BehaviorCodeReactionsTableColumnsEnum.TRIGGER_AT]: ['triggerCount'],
    [BehaviorCodeReactionsTableColumnsEnum.PRINT_COPIES]: ['printCopies'],
    [BehaviorCodeReactionsTableColumnsEnum.ACTION_REPEAT]: [
      'reactionMultiplier'
    ]
  };

  public columns = BehaviorCodeReactionsTableColumnsEnum;

  public showPagination: boolean;
  public hasPrivilegeToDelete: boolean;

  constructor(
    public confirmationDialog: AppConfirmationDialogService,
    private toastManager: AppToastManagerService,
    public behaviorCodeReactionsService: AppBehaviorCodeReactionsService,
    private privilegesService: AppPrivilegesService
  ) {
    super();
  }

  public ngOnInit() {
    this.showPagination = this.dataArr?.length < this.tableFilters?.count;

    this.hasPrivilegeToDelete = this.privilegesService.hasPrivilege(
      PrivilegeEnum.EDIT_BEHAVIOR_CODE_CONSEQUENCES
    );
  }

  public async deleteReactionFromBehavior(
    row: BehaviorCodeReactionUpdateDto
  ): Promise<void> {
    const reactionTemplateId = row.id;
    const ref = this.confirmationDialog.openDialog({
      title: `Remove Reaction`,
      content: 'Are you sure you want to remove the reaction?'
    });
    ref.afterClosed().subscribe(async (result: string) => {
      if (result === DEFAULT_DIALOG_RESULT.YES) {
        row.active = false;
        await this.behaviorCodeReactionsService.updateBehaviorCodeReaction(
          row,
          reactionTemplateId
        );
        this.toastManager.success('Reaction removed successfully!');
        // remove reaction from data array
        this.dataArr = this.dataArr.filter(
          (reaction) => reaction.id !== reactionTemplateId
        );

        if(row.reactionType === ReactionTypeEnum.SELECT_MENU && this.dataArr.length === 0) {
          window.location.reload();
        }
      }
    });
  }
}
